<template>
  <div>
    <v-app-bar app color="#1a3a2a" dark elevation="0" height="52">
      <div class="d-flex align-center" style="gap:8px;flex-shrink:0">
        <span style="font-size:1.2rem">🌱</span>
        <app-logo :size="0.95" :dark="true" />
        <span v-if="garden" style="font-size:0.85rem;opacity:0.7">— {{ garden.name }}</span>
      </div>

      <div class="d-flex align-center ml-4" style="flex:1;gap:4px">
        <v-btn
          v-for="tab in tabs"
          :key="tab.id"
          text
          x-small
          height="32"
          class="text-none white--text tab-nav-btn"
          :class="{ 'tab-nav-btn--active': activeTab === tab.id }"
          @click="navigate(tab.id)"
        >{{ $t(tab.labelKey) }}</v-btn>
      </div>

      <v-btn text x-small class="text-none setup-link-btn" to="/setup">{{ $t('nav.setup') }}</v-btn>
      <v-btn text x-small class="text-none logout-btn ml-1" @click="logout">Logout</v-btn>
    </v-app-bar>

    <v-main>
      <div v-if="loading" class="text-center" style="padding:60px;color:#666">{{ $t('garden.loading') }}</div>
      <div v-else-if="!garden" class="text-center" style="padding:80px 20px">
        <p style="margin-bottom:20px;color:#666">{{ $t('garden.noGarden') }}</p>
        <v-btn color="primary" dark rounded @click="showWizard = true">{{ $t('garden.createCta') }}</v-btn>
      </div>
      <v-container v-else fluid>
        <router-view />
      </v-container>
    </v-main>

    <v-dialog v-model="showWizard" max-width="520" scrollable>
      <v-card>
        <onboarding-wizard mode="create" @done="showWizard = false" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { gardenApi } from "@/services/api"
import AppLogo from '@/components/AppLogo.vue'
import OnboardingWizard from '@/components/onboarding/OnboardingWizard.vue'

const GARDEN_ID_KEY = "jardin_garden_id"

export default {
  name: "Dashboard",
  components: { AppLogo, OnboardingWizard },
  data() {
    return {
      showWizard: false,
      tabs: [
        { id: "tasks", labelKey: "nav.tabs.tasks" },
        { id: "planning", labelKey: "nav.tabs.planning" },
        { id: "fiches", labelKey: "nav.tabs.fiches" },
        { id: "priorites", labelKey: "nav.tabs.priorites" },
        { id: "calendar",  labelKey: "nav.tabs.calendar" },
      ],
    }
  },
  computed: {
    ...mapState("garden", ["garden", "loading"]),
    ...mapState("ui", ["activeTab"]),
  },
  async created() {
    await this.loadGarden()
    if (this.$route.query.onboarding === '1') {
      this.showWizard = true
      this.$router.replace({ query: {} }).catch(() => {})
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout")
      this.$router.push("/login").catch(() => {})
    },
    async loadGarden() {
      let gardenId = localStorage.getItem(GARDEN_ID_KEY)
      if (!gardenId) {
        const { data } = await gardenApi.list()
        if (data.results.length === 0) return
        gardenId = data.results[0].id
        localStorage.setItem(GARDEN_ID_KEY, gardenId)
      }
      const data = await this.$store.dispatch("garden/loadDashboard", gardenId)
      if (data?.task_groups) {
        this.$store.dispatch("tasks/setFromDashboard", data.task_groups)
      }
    },
    navigate(tab) {
      this.$store.commit("ui/SET_TAB", tab)
      this.$router.push("/" + tab).catch(() => {})
    },
  },
}
</script>

<style scoped>
.tab-nav-btn {
  font-size: 0.85rem !important;
  color: rgba(255, 255, 255, 0.7) !important;
  border-radius: 6px !important;
}
.tab-nav-btn--active {
  background: rgba(255, 255, 255, 0.2) !important;
  color: #fff !important;
  font-weight: 700 !important;
}
.tab-nav-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  color: #fff !important;
}
.setup-link-btn {
  font-size: 0.8rem !important;
  color: rgba(255, 255, 255, 0.6) !important;
  flex-shrink: 0;
}
.setup-link-btn:hover {
  color: #fff !important;
}
.logout-btn {
  font-size: 0.8rem !important;
  color: rgba(255, 255, 255, 0.5) !important;
  flex-shrink: 0;
}
.logout-btn:hover {
  color: #fff !important;
}
</style>
